export class Payeeaccountinfo{
    constructor(){}

    Acctid: string = null;

    Deserialize(input:any){
        this.Acctid = input.payeeaccountinfo.acctid._text;
        return this;
    }
}